/**
 * @file AssetListView.js
 * @description Standard list component with columns for the Asset Library.
 */

import styles from '../AssetLibrary.module.scss';
import { getDateFromZulu } from '../../helpers/getDateFromZulu';
import { getText } from '../../../i18n';

const AssetListView = ({
    assets,
    handleClick,
    isClientResourceView = false,
    onResourceClick,
}) => {
    return (
        <div className="table-responsive-xxl w-100">
            <div className={styles.tableContainer}>
                <table
                    className={`table table-hover align-middle ${styles.tableDiv}`}
                >
                    <thead className="custom-table-header table-light">
                        <tr>
                            <th className={styles.tableColumnM}>
                                <span>{getText('msg_709a23220f2c')}</span>
                            </th>
                            <th className={styles.tableColumnL}>
                                <span>{getText('msg_1910e1df6652')}</span>
                            </th>
                            <th className={styles.tableColumnXS}>
                                <span>{getText('msg_3deb74565196')}</span>
                            </th>
                            <th className={styles.tableColumnS}>
                                <span>{getText('msg_accf40c89baa')}</span>
                            </th>
                            <th className={styles.tableColumnS}>
                                <span>{getText('msg_43de2bcd6337')}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {assets.map((asset, index) => (
                            <tr key={asset.id}>
                                <td
                                    onClick={() =>
                                        isClientResourceView
                                            ? onResourceClick(asset)
                                            : handleClick(index)
                                    }
                                    className={`${styles.columnBold} ${styles.columnActive}`}
                                >
                                    {asset.name}
                                </td>
                                <td className={styles.columnRegular}>
                                    {asset.description}
                                </td>
                                <td className={styles.columnBold}>
                                    {asset.fileType.toUpperCase()}
                                </td>
                                <td className={styles.columnRegular}>
                                    {getDateFromZulu(asset.createdAt)}
                                </td>
                                <td className={styles.columnRegular}>
                                    {asset.createdBy}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AssetListView;
